const blocksBodyWithColumns = Array.from(document.querySelectorAll(".block-body-with-columns"));

blocksBodyWithColumns.forEach(function (block) {

    const btnReadMore = block.querySelector(".block-read-more");

    btnReadMore.addEventListener("click", function (e) {

        e.preventDefault();
        
        const blockContentCenter = block.querySelector(".content-center");
        const blockContentRight = block.querySelector(".content-right");

        if (!blockContentCenter.classList.contains('active')) {
            blockContentCenter.classList.add('active');
        } else {
            blockContentCenter.classList.remove('active');
        }

        if (!blockContentRight.classList.contains('active')) {
            blockContentRight.classList.add('active');
        } else {
            blockContentRight.classList.remove('active');
        }

        if (!e.target.classList.contains('active')) {
            e.target.classList.add('active');
            e.target.textContent = e.target.dataset.showLess;
        } else {
            e.target.classList.remove('active');
            e.target.textContent = e.target.dataset.showMore;
        }

    });

});